module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Barbgs' Blog","short_name":"barbgsBlog","start_url":"/northern-territory","background_color":"#D43826","theme_color":"#D43826","display":"standalone","icon":"src/images/northern-territory/icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
